module.exports = __webpack_public_path__ + "img/sanbao-pijian.441f1b0b.png";